// import React, { useEffect, useState } from "react";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query';

import "@mantine/core/styles.css";
import Login from "./components/LoginPage/AuthenticationTitle";
import Member from "./components/MemberPage/Member";
import Admin from "./components/AdminPage/Admin";
import Staff from "./components/StaffPage/Staff";
import MainPage from "./components/MainPage/MainPage";
import FeedCategory from "./components/FeedCategoryPage/FeedCategory";
import TransactionPage from "./components/TransactionPage/TransactionPage";
import KpiPage from "./components/KpiPage/kpiPage";
import RequireAuth from "./auth/RequireAuth";
import Banner from "./components/BannerPage/Banner";
import Voucher from "./components/VoucherPage/Voucher";
import Notification from "./components/Notification/notification";
import Order from "./components/OrderPage/Order";
import { ThemeProvider } from "./ThemeContext";
import General from "./General";
import SelectedStaff from "./components/StaffPage/SelectedStaff";
import StaffDashboard from "./components/StaffDashboardPage/staffDashboard";
import Merchandise from "./components/MerchandisePage/merchandise";
import NotFound from "./components/NotFoundPage/NotFound";
import Dealer from "./components/DealerPage/Dealer";
import DealerRebate from "./components/DealerRebatePage/DealerRebate";
import Corporate from "./components/CorporatePage/Corporate";
import VoucherBirthday from "./components/VoucherBirthdayPage/VoucherBirthday";

// import PDFPriceList from "./components/PDFPriceListPage/PDFPriceList";
import SplashScreen from "./components/SplashScreenPage/SplashScreen";
// import Prebuild from "./components/PrebuildPage/Prebuild";
import Terms from "./components/TermsPage/Terms";
import PCComponent from "./components/PCComponentPage/PCComponent";
import PCComponentIncomplete from "./components/PCComponentIncompletePage/PCComponentIncomplete";
import PCComponentParameter from "./components/PCComponentParameterPage/PCComponentParameter";
import PCComponentEdit from "./components/PCComponentEditPage/PCComponentEdit";
import AllItem from "./components/AllItemPage/AllItem";
import StoreItem from "./components/StoreItemPage/StoreItem";
import StoreItemIncomplete from "./components/StoreItemIncompletePage/StoreItemIncomplete";
import StoreItemEdit from "./components/StoreItemEditPage/StoreItemEdit";

import GamesFPSGPU from "./components/GamesFPSPage/GamesFPSGPU";
import GamesFPSGames from "./components/GamesFPSPage/GamesFPSGames";

import ManageFPS from "./components/GamesFPSPage/ManageFPS";

import BuildConfigPrebuild from "./components/BuildConfigPrebuildPage/BuildConfigPrebuild";
import BuildConfigCreate from "./components/BuildConfigCreatePage/BuildConfigCreate";
import BuildConfigUpdate from "./components/BuildConfigUpdatePage/BuildConfigUpdate";
import BuildConfigCustom from "./components/BuildConfigCustomPage/BuildConfigCustom";

import BannerWeb from "./components/BannerWebPage/BannerWeb";

import Review from "./components/ReviewPage/Review";

import WebOrder from "./components/WebOrderPage/WebOrder";
import WebOrderView from "./components/WebOrderViewPage/WebOrderView";

import ContactUs from "./components/ContactUsPage/ContactUs";
import BuildConfigEasy from "./components/BuildConfigEasyPage/BuildConfigEasy";
import Contact from "./components/ContactPage/Contact";
import PdfGpu from "./components/PdfGpuPage/PdfGpu";
import FastPassHistory from "./components/FastPassHistoryPage/FastPassHistory";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { 
            refetchOnWindowFocus: false,
            // refetchOnMount: false,
            // refetchOnReconnect: false,
            retry: false,
        }
    },
});

function App() {
  return (
    <div>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <MantineProvider>
                <BrowserRouter>
                    <Routes>
                    {/* <Route
                        path="/"
                        Component={() => <Navigate to={"/admin/login"} />}
                    /> */}
                    <Route
                        path="/"
                        Component={() => <Navigate to={"/login"} />}
                    />
                    <Route path="/login" element={<Login />} />

                    {/* <Route path="/admin/login" element={<Login />} />
                    <Route path="/staff/login" element={<Login />} /> */}

                    <Route element={<RequireAuth allowedRoles={['admin', 'content']}/>}>
                        <Route element={<General />}>
                            <Route path="/feed" element={<MainPage />} />
                            <Route path="/feed-category" element={<FeedCategory />} />
                        </Route>
                    </Route>

                    <Route element={<RequireAuth allowedRoles={['admin', 'manager']}/>}>
                        <Route element={<General />}>
                            <Route path="/dealer" element={<Dealer />} />
                            <Route path="/dealer/:curr" element={<Dealer />} />
                            <Route path="/dealer/rebate/:uid" element={<DealerRebate />} />

                            <Route path="/corporate" element={<Corporate />} />
                            <Route path="/corporate/:curr" element={<Corporate />} />
                        </Route>
                    </Route>

                    {/* <Route element={<RequireAuth allowedRoles={['admin', 'price-list']}/>}>
                        <Route element={<General />}>
                            <Route path="/pdf-price-list" element={<PDFPriceList />}/>
                        </Route>
                    </Route> */}

                    <Route element={<RequireAuth allowedRoles={['admin']}/>}>
                        <Route element={<General />}>
                            {/* <Route path="/feed" element={<MainPage />} /> */}
                            <Route path="/banner" element={<Banner />} />
                            <Route path="/banner-web" element={<BannerWeb />} />
                            <Route path="/review" element={<Review />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/pdf-gpu" element={<PdfGpu />} />
                            <Route path="/voucher" element={<Voucher />} />
                            <Route path="/voucher/:curr" element={<Voucher />} />

                            
                            <Route path="/voucher-birthday" element={<VoucherBirthday />} />

                            <Route path="/notification" element={<Notification />} />

                            <Route path="/order" element={<Order />} />
                            <Route path="/order/:curr" element={<Order />} />

                            {/* <Route path="/dealer" element={<Dealer />} />
                            <Route path="/dealer/:curr" element={<Dealer />} />
                            <Route path="/dealer/rebate/:uid" element={<DealerRebate />} />

                            <Route path="/corporate" element={<Corporate />} />
                            <Route path="/corporate/:curr" element={<Corporate />} /> */}

                            <Route path="/member" element={<Member />} />
                            <Route path="/fast-pass-history" element={<FastPassHistory />} />
                            <Route path="/admin" element={<Admin />} />

                            <Route path="staff" element={<Staff />} />
                            <Route path="staff/:id/:curr/" element={<SelectedStaff />} />
                            <Route path="/staff" element={<Staff />} />
                            <Route path="staff/:id/:curr" element={<SelectedStaff />} />

                            <Route path="/merchandise" element={<Merchandise />} />

                            <Route
                                path="/transaction-history/:coins"
                                element={<TransactionPage />}
                            />
                            <Route
                                path="/transaction-history/:coins"
                                element={<TransactionPage />}
                            />



                            <Route path="/kpi" element={<KpiPage />} />

                            {/* <Route path="/pdf-price-list" element={<PDFPriceList />}/> */}
                            <Route path="/splash-screen" element={<SplashScreen />}/>
                            {/* <Route path="/custom" element={<Prebuild />}/> */}
                            <Route path="/terms" element={<Terms />}/>

                            <Route path="/pc-component" element={<PCComponent />}/>
                            <Route path="/pc-component/:curr" element={<PCComponent />} />

                            <Route path="/pc-component/update/:id" element={<PCComponentEdit />} />

                            <Route path="/pc-component-incomplete" element={<PCComponentIncomplete />}/>
                            <Route path="/pc-component-incomplete/:curr" element={<PCComponentIncomplete />} />

                            <Route path="/pc-component-parameter" element={<PCComponentParameter />}/>

                            <Route path="/pc-component-incomplete/update/:id" element={<PCComponentEdit />} />

                            <Route path="/all-item" element={<AllItem />} />
                            
                            <Route path="/store-item" element={<StoreItem />} />
                            <Route path="/store-item/:curr" element={<StoreItem />} />

                            <Route path="/store-item/update/:id" element={<StoreItemEdit />} />

                            <Route path="/store-item-incomplete" element={<StoreItemIncomplete />} />
                            <Route path="/store-item-incomplete/:curr" element={<StoreItemIncomplete />} />
                            
                            <Route path="/store-item-incomplete/update/:id" element={<StoreItemEdit />} />

                            <Route path="/games-fps" element={<GamesFPSGPU />} />
                            <Route path="/games-fps/gpu" element={<GamesFPSGPU />} />
                            <Route path="/games-fps/games" element={<GamesFPSGames />} />
                            
                            <Route path="/games-fps/update/:id" element={<ManageFPS />} />

                            <Route path="/build-config-prebuild" element={<BuildConfigPrebuild />} />
                            <Route path="/build-config-prebuild/create" element={<BuildConfigCreate />} />
                            <Route path="/build-config-prebuild/update/:id" element={<BuildConfigUpdate />} />

                            <Route path="/build-config-custom" element={<BuildConfigCustom />} />
                            <Route path="/build-config-custom/create" element={<BuildConfigCreate />} />
                            <Route path="/build-config-custom/update/:id" element={<BuildConfigUpdate />} />

                            <Route path="/build-config-easy" element={<BuildConfigEasy />} />
                            <Route path="/build-config-easy/create" element={<BuildConfigCreate />} />
                            <Route path="/build-config-easy/update/:id" element={<BuildConfigUpdate />} />

                            <Route path="/web-order" element={<WebOrder />} />
                            <Route path="/web-order/:curr" element={<WebOrder />} />

                            <Route path="/web-order/view/:id" element={<WebOrderView />} />

                            <Route path="/contact-us-message" element={<ContactUs />} />

                        </Route>
                        <Route path="/staff/dashboard" element={<StaffDashboard />} />
                    </Route>

                    <Route path='/404' element={<NotFound />} />

                        {/* If route not found redirect to home page for now */}
                        <Route path="*" element={<Navigate to="/404" replace />} />
                    </Routes>
                </BrowserRouter>
                </MantineProvider>
            </ThemeProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
